module.exports = __webpack_public_path__ + "img/compentation_experience_primary.8d81a79f.svg";